import DeviceConnectionSuccess from './device_connection_success'

export default DeviceConnectionSuccess